import React from 'react';
import LastSeenCell from '../AssetList/components/LastSeenCell';
import { icons } from 'assets/icons/index';
import { getLastSeenString, getValueSafely } from 'utils/utils';
import { infoStyle, StyledTable } from './styles';
import BatterySpan from './BatterySpan';
import LocationSection from './LocationSection';
import { Asset } from 'types/asset';
import { Horizontal, Vertical } from 'gls';
import AccuracyRangeSpan from 'views/global/AccuracyRangeSpan';

export default function AssetDetailsTab({ asset }: { asset: Asset }) {
  const deviceSource = asset.assigned_beacon?.import_info.source;

  return (
    <Vertical spacing={10}>
      <Horizontal className={infoStyle} spacing={5}>
        <icons.InfoIcon aria-label='note' width='14px' height='14px' />
        <span> Please note, estimated information was derived from the beacon.</span>
      </Horizontal>
      <StyledTable data-test-id="asset-details-estimate" style={{ marginBottom: 0 }}>
        <tbody>
          <tr>
            <td>Last Seen:</td>
            <td>
              <LastSeenCell timestamp={asset.last_location_update_timestamp} />
              {asset.last_location_update_timestamp &&
                ` ${getLastSeenString(asset.last_location_update_timestamp)}`}
            </td>
          </tr>
          <tr>
            <td>Accuracy Range:</td>
            <td>
              <AccuracyRangeSpan location={asset.location} />{' '}
            </td>
          </tr>

          <tr>
            <td>Battery:</td>
            <td>
              <BatterySpan asset={asset} />
            </td>
          </tr>
          <tr>
            <td valign="top">Location:</td>
            <td>
              <LocationSection asset={asset} />
            </td>
          </tr>
          <tr>
            <td>Beacon ID:</td>
            <td>{getValueSafely(asset.assigned_beacon?.id)}</td>
          </tr>
          <tr>
            <td>Beacon Type:</td>
            <td>
              {getValueSafely(asset.assigned_beacon?.beacon_type)}
              {deviceSource && ` - ${deviceSource}`}
            </td>
          </tr>
        </tbody>
      </StyledTable>
    </Vertical>
  );
}

